// Module
var code = `<div ng-if="ctrl.isLabelVisible" class="job-status job-service-type"> <div class="job-status-item"> <div class="light-grey"> {{ 'JOB_VIEW_SERVICE_TYPE_LABEL' | translate }}: </div> </div> <div class="job-status-item"> <div class="light-grey"> <span> {{ctrl.currentServiceTypeTitle | translate }} </span> </div> </div> </div>`;
// Exports
export default code;